import { useTheme, useMediaQuery } from '@mui/material';

/**
 * useResponsive — détecte la taille d'écran courante.
 * Basé sur les breakpoints MUI pour cohérence avec le reste de l'UI.
 *
 * @returns {{ isMobile, isTablet, isDesktop }}
 */
const useResponsive = () => {
  const theme = useTheme();
  const isMobile  = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet  = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return { isMobile, isTablet, isDesktop };
};

export default useResponsive;
